module.exports = {
  AnimationOptions: {
    PluginName: "Animaciones",
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    opacity: "Opacidad",
    padding: "Padding",
    pos: "Posición",
    radius: "Radio",
    source: "Imagen",
    scale: "Zoom",
    message_mark_xy:
      "Ha introducido un valor incorrecto. Debe introducir dos números separados por coma. Ej. 4.56,90.76",
    hyperlink: "Enlaza Con",
    link_placeholder: "http://...",
    allowDeformed: "No ajustar a contenedor",
    replayWebp: "Repetir al iniciar la escena (WebP / GIF)",
  },
};
